import React from 'react';


import Container from 'components/Container';

export const App = () => {
  return (
    <div>
      <Container />
    </div>
  )
}
